
const  init = (params) => {
  const AK = 'EDq7wo8XC7ODWwGDmHGVl2vZHpVxK4kZ';
    const BMapGL_URL = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${AK}&callback=onBMapCallback`;

    return new Promise((resolve, reject) => {
      // 如果已加载直接返回
      if(typeof BMapGL !== 'undefined'){
        resolve(BMapGL);
        return true;
      }

      // 百度地图异步回调处理
      window.onBMapCallback = () => {
        console.log('百度地图脚本初始化成功...');
        resolve(BMapGL);
      }

      let scriptNode = document.createElement('script');
      scriptNode.setAttribute('type', 'text/javascript');
      scriptNode.setAttribute('src', BMapGL_URL);
      document.body.appendChild(scriptNode);

    })
}
const initVersion2 = () => {
  const AK = 'tYsonVwI79179q0zW89ZqvRp'
    const BMap_URL =`https://api.map.baidu.com/api?v=2.0&ak=${AK}&callback=onBMapCallback`;
    return new Promise((res,rej) => {
      if(typeof BMap !== 'undefined'){
        res(BMap)
        return true
      }
      window.onBMapCallback = () => {
        console.log('百度地图脚本初始化成功...');
        res(BMap);
      }
      let scriptNode = document.createElement('script');
      scriptNode.setAttribute('type', 'text/javascript');
      scriptNode.setAttribute('src', BMap_URL);
      document.body.appendChild(scriptNode);
    })
}
export default {
  init,
  initVersion2
}